module.exports = __webpack_public_path__ + "img/sandbox-flair.34237ae1.svg";